// extracted by mini-css-extract-plugin
module.exports = {"body":"EmptyShop_body__whPRF"};